/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/design/pixinvent
==========================================================================================*/


export default {
  SET_PROJECTS (state, designes) {
    state.designes = designes
  },
  REMOVE_RECORD (state, itemId) {
    const designIndex = state.designes.findIndex((u) => u.id === itemId)
    state.designes.splice(designIndex, 1)
  }
}
